import React from "react";
import { Combo } from "../../common/components/comboBox";
import { TechnicianDto } from "../../generated";
import { formGroup } from "../../common/components/formGroup";
import Store from "../TechiniciansStore";
import { Loading } from "../../common/components/loading";

const Combobox = Combo<TechnicianDto>();
interface Props {
    value: number | null,
    onChange: (type: TechnicianDto | null) => void
    error?: string;
    label?: string;
    onBlur?: React.FocusEventHandler;
    onFocus?: React.FocusEventHandler;
    readonly?: boolean;
}
export const TechnicianSelectorNoFormGroup = ({ onChange, value, error, label, onBlur, onFocus, readonly }: Props) => {
    const data = Store.useAll();
    if (!data)
        return <Loading />
    return <Combobox
        label={label ?? "Tecnico"}
        allowNull
        data={data}
        textField={x => `${x.firstName} ${x.lastName}`}
        onSelect={x => onChange(x ?? null)}
        value={data.find(technician => technician.id == value) ?? null}
        error={error}
        onBlur={onBlur}
        onFocus={onFocus}
        itemComponent={item => <div>
            <i className="fas fa-circle me-2" style={{ color: item.item.color }} /> {`${item.item.firstName} ${item.item.lastName}`}
        </div>}
        readonly={readonly}
    />;
}
export const TechnicianSelector = formGroup(TechnicianSelectorNoFormGroup);